import React, { createContext, useContext, useState } from "react";

type StepperContextType = {
  formData: Record<string, any>;
  updateFormData: (key: string, value: any) => void;
  resetFormData: () => void;
};

const StepperContext = createContext<StepperContextType | null>(null);

export const useStepperData = () => {
  const context = useContext(StepperContext);
  if (!context) {
    throw new Error("useStepperData must be used within a StepperProvider");
  }
  return context;
};

export const StepperProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [formData, setFormData] = useState<Record<string, any>>({});

  const updateFormData = (key: string, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const resetFormData = () => {
    setFormData({});
  };

  return (
    <StepperContext.Provider
      value={{ formData, updateFormData, resetFormData }}
    >
      {children}
    </StepperContext.Provider>
  );
};
